import React from 'react';
import { RichTextDescription } from 'coop-adventure-engine';
import { RichTextRenderer } from '../ui/RichTextRenderer';

export interface SceneDisplayProps {
  title?: string;
  description: string | RichTextDescription;
  imageUrl?: string;
  className?: string;
  onInlineOptionClick?: (optionId: string) => void;
  onSyncOptionSelect?: (syncVar: string, targetScene: string, characterNames?: string[], targetByCharacter?: Record<string, string>, syncEffects?: string) => void;
}

const SceneDisplay: React.FC<SceneDisplayProps> = ({
  title,
  description,
  imageUrl,
  className = '',
  onInlineOptionClick,
  onSyncOptionSelect
}) => {
  return (
    <div className={`bg-white rounded-lg shadow-sm border border-gray-200 ${className}`}>
      {/* Scene Image */}
      {imageUrl && (
        <div className="aspect-video w-full overflow-hidden rounded-t-lg">
          <img
            src={imageUrl}
            alt={title || 'Scene image'}
            className="h-full w-full object-cover"
          />
        </div>
      )}
      
      {/* Scene Content */}
      <div className="p-6">
        {/* Scene Title */}
        {title && (
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            {title}
          </h2>
        )}
        
        {/* Scene Description */}
        <div className="prose prose-gray max-w-none">
          <RichTextRenderer 
            description={description}
            {...(onInlineOptionClick && { onInlineOptionClick })}
            {...(onSyncOptionSelect && { onSyncOptionSelect })}
            className="rich-text text-gray-700 leading-relaxed"
          />
        </div>
      </div>
    </div>
  );
};

export default SceneDisplay;
